"use client";

import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";

// Skeleton loader for footer menu
function MenuSkeleton() {
  return <div className="flex flex-wrap justify-center gap-6 mb-8 animate-pulse">
      {[...Array(4)].map((_, i) => <div key={i} className="h-4 w-16 bg-muted rounded" />)}
    </div>;
}
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <MenuSkeleton />;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors duration-200">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-6 px-4 md:px-8 border-t border-border/20">
      <div className="max-w-7xl mx-auto flex flex-col items-center">

        {/* Social Media Links */}
        <div className="flex items-center justify-center gap-8 mb-10">
          <Link to="https://www.youtube.com/@yohanneswakgariofficialcha6717" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
            <Youtube size={24} />
          </Link>

          <Link to="https://www.instagram.com/yohannes_wakgari/" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <Instagram size={24} />
          </Link>

          <Link to="https://www.facebook.com/people/Gospel-musician-Yohannes-Wakgari/100044576552931/" className="text-muted-foreground hover:text-primary transition-colors duration-300" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
            <Facebook size={24} />
          </Link>
        </div>

        {/* Footer Navigation Menu */}
        <MenuProvider menu_id="17">
          <FooterNavigation />
        </MenuProvider>

        {/* Copyright */}
        <p className="text-sm text-muted-foreground mb-16 text-center">
          © {currentYear} ZemaYohannes. All rights reserved.
        </p>

        {/* Bottom Info Section */}
        <div className="w-full pt-6 border-t border-border/30 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-2">
            <span>Frontend Preview Only.</span>
            <Link to="#" className="text-green-500 hover:text-green-400 transition-colors" target="_blank" rel="noopener noreferrer">
              Wake up servers
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <span>Made with Emergent</span>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612944/img/emergent_logo_icon.png" alt="Emergent Logo" className="h-4 w-auto opacity-70 grayscale hover:grayscale-0 transition-all duration-300" />
          </div>
        </div>

      </div>
    </section>;
}